import React, { Component } from 'react';
import A11yFontIcon from 'components/A11yFontIcon';
import './GiphySearchBar.css';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      term: ''
    };
    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange(term) {
    this.setState({ term });
    this.props.onTermChange(term);
  }

  render() {
    const term = this.props.term || this.state.term;
    return (
      <div className="search-giphy-bar">
        <A11yFontIcon
          className="search-icon"
          icon="search"
          alt="Search GIPHY"
        />
        <input
          type="text"
          placeholder={'Search GIPHY...'}
          aria-label={'Search for GIFs'}
          onChange={event => this.onInputChange(event.target.value)}
          value={term}
        />
      </div>
    );
  }
}

export default SearchBar;
